import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import eolSlice from "./eolSlice";
import eolTestsSlice from "./eolTestsSlice";
import filterSlice from "./filterSlice";
import loaderSlice from "./loaderSlice";
import rideSlice from "./testRideSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  eol: eolSlice,
  eolTests: eolTestsSlice,
  filter: filterSlice,
  testRide: rideSlice,
  loader: loaderSlice,
});

export default rootReducer;
